import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractApiService } from './abstract-api-service';

@Injectable({
	providedIn: 'root',
})
export class AuthConfigService extends AbstractApiService {

	constructor(protected http: HttpClient) {
		super(http);
	}

	get prefix(): string {
		return 'u/auth-config';
	}

	getConfig(): Observable<any> {
		return this.get('');
	}
}
